import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import Game from './Game.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'GameRouteWrapper',
  setup(__props) {

const route = useRoute()

// When this key is changed, Game component will be re-created
const key = computed(() => route.params.game as string)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Game, { key: key.value }))
}
}

})